import React, {useState, useEffect, useRef} from 'react';
import {Button} from "primereact/button";
import {withTranslation} from 'react-i18next';
import {Dialog} from "primereact/dialog";
import {Message} from "primereact/message";
import {Tooltip} from "primereact/tooltip";
import {CSSTransition} from 'react-transition-group'; // Import transition
import Cookies from "js-cookie";

const HelpComponent = (props) => {

  const {t, i18n} = props;
  const isSuperUser = Cookies.get('roles') && Cookies.get('roles').toString().includes('ROLE_SUPER_ADMIN');
  const showHelpPlaceholder = isSuperUser && props.type !== 'field' && props.type !== 'custom_message' && props.position !== 'UNDER_HELP_BUTTON';
  const placeholderParts = [`type: ${props.type || '-'}`];
  if (props.position !== undefined && props.position !== null && props.position !== '') {
    placeholderParts.push(`position: ${props.position}`);
  }
  if (props.tabNumber !== undefined && props.tabNumber !== null && props.tabNumber !== '') {
    placeholderParts.push(`tab_number: ${props.tabNumber}`);
  }
  if (props.sectionNumber !== undefined && props.sectionNumber !== null && props.sectionNumber !== '') {
    placeholderParts.push(`section_number: ${props.sectionNumber}`);
  }
  const placeholderText = placeholderParts.join(' | ');
  const [loading, setLoading] = useState(true);
  const [dialogHelp, setDialogHelp] = useState(false);
  const [fieldMessage, setFieldMessage] = useState('');
  const [qGlobalMessages, setQGlobalMessages] = useState([]);
  const [sGlobalMessages, setSGlobalMessages] = useState([]);
  const [bGlobalMessages, setBGlobalMessages] = useState([]);
  const fieldTooltipTargetClassRef = useRef(`tt-on-field-help-${Math.random().toString(36).slice(2, 11)}`);

  useEffect(() => {
    if (props.field && window.App.state.help) {
      let message = window.App.state?.help[props.type]?.filter(item => item.field === props.field)
      if (message && message[0] && message[0].message) {
        setFieldMessage(message[0].message)
      }
    }
    if (props.type === 'global' && window.App.state.help && window.App.state.help.global && window.App.state.help.global[0]) {
      let message = window.App.state.help[props.type].filter(item => (item.position === 'UNDER_HELP_BUTTON' || item.position === null))
      if (message && message[0]) {
        setQGlobalMessages(message)
      }
    } else {
      setQGlobalMessages([])
    }
    if ((props.type === 'edit_box' || props.type === 'show_box') && window.App.state.help && (window.App.state.help.edit_box
      || window.App.state.help.show_box) && window.App.state.help.global && window.App.state.help.global[0]) {
      let message = window.App.state.help[props.type].filter(item => (item.position === 'UNDER_HELP_BUTTON' || item.position === null))
      if (message && message[0]) {
        setBGlobalMessages(message)
      }
    } else {
      setBGlobalMessages([])
    }
    if (props.type === 'site' && window.App.state.help && window.App.state.help.site && window.App.state.help.site[0]) {
      let message = window.App.state.help[props.type].filter(item => (item.position === 'UNDER_HELP_BUTTON' || item.position === null))
      if (message && message[0]) {
        setSGlobalMessages(message)
      }
    } else {
      setSGlobalMessages([])
    }
    setLoading(false)
  }, [window.App.state.help])

  const [messages, setMessages] = useState([]);
  useEffect(() => {
    // Simulated data fetch
    if (props.type === 'global' && window.App.state.help?.global) {
      const globalMessages = window.App.state.help.global.filter(item => item.position === props.position);
      setMessages(globalMessages || []);
    }
  }, [props.type, props.position]);

  return (
    <>
      {/*{loading ? (*/}
      {/*  <></>*/}
      {/*) : (*/}
      <div className={`helpComponent ${props.type === 'custom_message' ? 'p-d-block' : 'p-d-inline'}`} style={(props.type === 'edit_box' || props.type === 'show_box') ? {position: 'relative'} : {}}>
        {showHelpPlaceholder &&
          <div className="help-placeholder">
            {placeholderText}
          </div>
        }
        {props.type === 'custom_message' && props.message &&
          <Message
            severity={props.level == null ? '' : props.level === 'LEVEL_SECONDARY' ? 'secondary' : props.level === 'LEVEL_WARNING' ? 'warn' : props.level === 'LEVEL_DANGER' ? 'error' : props.level.replace('LEVEL_', '').toLowerCase()}
            className={props.level === null ? "p-d-block p-my-1 p-border-secondary" : props.level === 'LEVEL_SECONDARY' ? "p-d-block p-my-1 p-bg-secondary" : "p-d-block p-my-1"}
            text={props.message}
          />
        }
        {window.App.state.help &&
          <>
            {props.type === 'global' && props.position === 'UNDER_HELP_BUTTON' &&
              <>
                {qGlobalMessages && qGlobalMessages[0] &&
                  <Button type="button" className="p-button-warning" icon={"pi pi-question-circle"}
                          onClick={() => {
                            setDialogHelp(true)
                          }}/>
                }
                <Dialog header={t('help')} visible={dialogHelp} dismissableMask={true}
                        onHide={() => {
                          setDialogHelp(false)
                        }}>
                  {window.App.state?.help?.global?.map((help, index) => {
                    if (help.position === 'UNDER_HELP_BUTTON' || help.position === null) {
                      if (help.level == null) {
                        return (
                          <Message severity="" className={"p-d-block p-my-1 p-border-secondary"} text={help.message}/>
                        )
                      } else if (help.level == 'LEVEL_SECONDARY') {
                        return (
                          <Message severity="secondary" className={"p-d-block p-my-1 p-bg-secondary"}
                                   text={help.message}/>
                        )
                      } else {
                        let _severity = ''
                        if (help.level == 'LEVEL_WARNING') {
                          _severity = 'warn'
                        } else if (help.level == 'LEVEL_DANGER') {
                          _severity = 'error'
                        } else {
                          _severity = help.level.replace('LEVEL_', '')
                        }
                        return (
                          <Message severity={_severity.toString().toLowerCase()} className={"p-d-block p-my-1"}
                                   text={help.message}/>
                        )
                      }
                    }
                  })}
                </Dialog>
              </>
            }

            {props.type === 'global' && props.position === 'TOP_OF_THE_PAGE' &&
              <>
                {window.App.state?.help?.global?.map((help, index) => {
                  if (help.position === 'TOP_OF_THE_PAGE') {
                    if (help.level === null) {
                      return (
                        <Message severity="" className={"p-d-block p-m-0 p-mb-0 p-border-secondary global"}
                                 text={help.message} style={{borderRadius: '0px', marginBottom: '0px !important'}}/>
                      )
                    } else if (help.level == 'LEVEL_SECONDARY') {
                      return (
                        <Message severity="secondary" className={"p-d-block p-m-0 p-mb-0 p-bg-secondary global"}
                                 text={help.message} style={{borderRadius: '0px', marginBottom: '0px !important'}}/>
                      )
                    } else {
                      let _severity = ''
                      if (help.level == 'LEVEL_WARNING') {
                        _severity = 'warn'
                      } else if (help.level == 'LEVEL_DANGER') {
                        _severity = 'error'
                      } else {
                        _severity = help.level.replace('LEVEL_', '')
                      }
                      return (
                        <CSSTransition
                          key={index}
                          in={true}
                          appear={true}
                          timeout={300}
                          classNames="drop"
                        >
                          <Message severity={_severity.toString().toLowerCase()}
                                   className={"p-d-block p-m-0 p-mb-0 global"}
                                   text={help.message} style={{borderRadius: '0px', marginBottom: '0px !important'}}/>
                        </CSSTransition>
                      )
                    }
                  }
                })}
              </>
            }

            {props.type === 'site' && props.position === 'TOP_OF_THE_PAGE' &&
              <>
                {window.App.state?.help?.site?.map((help, index) => {
                  if ((help.position === 'TOP_OF_THE_PAGE' && props.url === help.url) || (help.position === 'TOP_OF_THE_PAGE' && !props.url)) {
                    if (help.level === null) {
                      return (
                        <Message severity="" className={"p-d-block p-my-2 p-border-secondary"} text={help.message}/>
                      )
                    } else if (help.level == 'LEVEL_SECONDARY') {
                      return (
                        <Message severity="secondary" className={"p-d-block p-my-2 p-bg-secondary"}
                                 text={help.message}/>
                      )
                    } else {
                      let _severity = ''
                      if (help.level == 'LEVEL_WARNING') {
                        _severity = 'warn'
                      } else if (help.level == 'LEVEL_DANGER') {
                        _severity = 'error'
                      } else {
                        _severity = help.level.replace('LEVEL_', '')
                      }
                      return (
                        <Message severity={_severity.toString().toLowerCase()} className={"p-d-block p-my-2"}
                                 text={help.message}/>
                      )
                    }
                  }
                })}
              </>
            }

            {props.type === 'site' && props.position === 'UNDER_HELP_BUTTON' &&
              <>
                {sGlobalMessages && sGlobalMessages[0] &&
                  <Button type="button" className="p-button-warning" icon={"pi pi-question-circle"}
                          onClick={() => {
                            setDialogHelp(true)
                          }}/>
                }
                <Dialog header={t('help')} visible={dialogHelp} dismissableMask={true}
                        onHide={() => {
                          setDialogHelp(false)
                        }}>
                  {window.App.state?.help?.site?.map((help, index) => {
                    if (help.position === 'UNDER_HELP_BUTTON' || help.position === null) {
                      if (help.level === null) {
                        return (
                          <Message severity="" className={"p-d-block p-my-1 p-border-secondary"} text={help.message}/>
                        )
                      } else if (help.level == 'LEVEL_SECONDARY') {
                        return (
                          <Message severity="secondary" className={"p-d-block p-my-1 p-bg-secondary"}
                                   text={help.message}/>
                        )
                      } else {
                        let _severity = ''
                        if (help.level == 'LEVEL_WARNING') {
                          _severity = 'warn'
                        } else if (help.level == 'LEVEL_DANGER') {
                          _severity = 'error'
                        } else {
                          _severity = help.level.replace('LEVEL_', '')
                        }
                        return (
                          <Message severity={_severity.toString().toLowerCase()} className={"p-d-block p-my-1"}
                                   text={help.message}/>
                        )
                      }
                    }
                  })}
                </Dialog>
              </>
            }

            {props.type === 'site' && props.position === 'IN_ACTIVE_BOX' &&
              <div className={""}>
                {window.App.state?.help?.site?.map((help, index) => {
                  if (help.position === 'IN_ACTIVE_BOX') {
                    if (help.level === null) {
                      return (
                        <Message severity="" className={"p-d-block p-my-1 p-border-secondary"} text={help.message}/>
                      )
                    } else if (help.level == 'LEVEL_SECONDARY') {
                      return (
                        <Message severity="secondary" className={"p-d-block p-my-1 p-bg-secondary"}
                                 text={help.message}/>
                      )
                    } else {
                      let _severity = ''
                      if (help.level == 'LEVEL_WARNING') {
                        _severity = 'warn'
                      } else if (help.level == 'LEVEL_DANGER') {
                        _severity = 'error'
                      } else {
                        _severity = help.level.replace('LEVEL_', '')
                      }
                      return (
                        <Message severity={_severity.toString().toLowerCase()} className={"p-d-block p-my-1"}
                                 text={help.message}/>
                      )
                    }
                  }
                })}
              </div>
            }

            {props.type === 'edit_box' && window.App.state.help.edit_box &&
              <>
                {window.App.state.help.edit_box.map((help, index) => {
                  if (help.level === null) {
                    return (
                      <Message severity="" className={"p-d-block p-m-3 p-border-secondary edit-box"} text={help.message}/>
                    )
                  } else if (help.level == 'LEVEL_SECONDARY') {
                    return (
                      <Message severity="secondary" className={"p-d-block p-m-3 p-bg-secondary edit-box"} text={help.message}/>
                    )
                  } else {
                    let _severity = ''
                    if (help.level == 'LEVEL_WARNING') {
                      _severity = 'warn'
                    } else if (help.level == 'LEVEL_DANGER') {
                      _severity = 'error'
                    } else {
                      _severity = help.level.replace('LEVEL_', '')
                    }
                    return (
                      <Message severity={_severity.toString().toLowerCase()} className={"p-d-block p-m-3 edit-box"}
                               text={help.message}/>
                    )
                  }
                })}
              </>
            }

            {props.type === 'show_box' && window.App.state.help.show_box &&
              <>
                {window.App.state.help.show_box.map((help, index) => {
                  if (help.level === null) {
                    return (
                      <Message severity="" className={"p-d-block p-m-3 p-border-secondary show-box"} text={help.message}/>
                    )
                  } else if (help.level == 'LEVEL_SECONDARY') {
                    return (
                      <Message severity="secondary" className={"p-d-block p-m-3 p-bg-secondary show-box"} text={help.message}/>
                    )
                  } else {
                    let _severity = ''
                    if (help.level == 'LEVEL_WARNING') {
                      _severity = 'warn'
                    } else if (help.level == 'LEVEL_DANGER') {
                      _severity = 'error'
                    } else {
                      _severity = help.level.replace('LEVEL_', '')
                    }
                    return (
                      <Message severity={_severity.toString().toLowerCase()} className={"p-d-block p-m-3 show-box"}
                               text={help.message}/>
                    )
                  }
                })}
              </>
            }

            {props.type === 'tab' && window.App.state.help.tab &&
              <>
                {window.App.state.help.tab.map((help, index) => {
                  if (Number(help.tab_number) === Number(props.tabNumber)) {
                    if (help.level === null) {
                      return (
                        <Message severity="" className={"p-d-block p-m-3 p-border-secondary"} text={help.message}/>
                      )
                    } else if (help.level == 'LEVEL_SECONDARY') {
                      return (
                        <Message severity="secondary" className={"p-d-block p-m-3 p-bg-secondary"} text={help.message}/>
                      )
                    } else {
                      let _severity = ''
                      if (help.level == 'LEVEL_WARNING') {
                        _severity = 'warn'
                      } else if (help.level == 'LEVEL_DANGER') {
                        _severity = 'error'
                      } else {
                        _severity = help.level.replace('LEVEL_', '')
                      }
                      return (
                        <Message severity={_severity.toString().toLowerCase()} className={"p-d-block p-m-3"}
                                 text={help.message}/>
                      )
                    }
                  }
                })}
              </>
            }

            {props.type === 'section' && window.App.state.help.section &&
              <>
                {window.App.state.help.section.map((help, index) => {
                  if (Number(help.tab_number) === Number(props.tabNumber)
                    && Number(help.section_number) === Number(props.sectionNumber)) {
                    if (help.level === null) {
                      return (
                        <Message severity="" className={"p-d-block p-m-3 p-border-secondary"} text={help.message}/>
                      )
                    } else if (help.level == 'LEVEL_SECONDARY') {
                      return (
                        <Message severity="secondary" className={"p-d-block p-m-3 p-bg-secondary"} text={help.message}/>
                      )
                    } else {
                      let _severity = ''
                      if (help.level == 'LEVEL_WARNING') {
                        _severity = 'warn'
                      } else if (help.level == 'LEVEL_DANGER') {
                        _severity = 'error'
                      } else {
                        _severity = help.level.replace('LEVEL_', '')
                      }
                      return (
                        <Message severity={_severity.toString().toLowerCase()} className={"p-d-block p-m-3"}
                                 text={help.message}/>
                      )
                    }
                  }
                })}
              </>
            }

            {fieldMessage &&
              <>
                <i
                  className={`pi pi-question-circle p-mr-2 ${fieldTooltipTargetClassRef.current}`}
                  data-pr-tooltip={fieldMessage}
                  data-pr-position="top"
                ></i>
                <Tooltip target={`.${fieldTooltipTargetClassRef.current}`} event="hover"/>
              </>
            }
          </>
        }
      </div>
      {/*)}*/}
    </>
  )
}
export default withTranslation('common')(HelpComponent);
